import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { CLASSROOM_TYPE_COLOR,
  CLASSROOM_TYPE_COLOR_HOVER,
  CLASSROOM_TYPE_COLOR_BACKGROUND,
  CLASSROOM_TYPE_COLOR_INFO,
  CLASSROOM_TYPE_ICON } from '../../Constants'

const ListItemContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 4px;
  padding: 4px 8px;
  height: 50px;
  cursor: ${props => !props.isHeader ? 'pointer' : 'default'};
  background-color: ${props => props.isActive ? CLASSROOM_TYPE_COLOR_BACKGROUND.active : CLASSROOM_TYPE_COLOR_BACKGROUND[props.type]};
  border-radius: 5px;
  transition: background-color 200ms ease-out;

  &:hover {
    ${props => !props.isHeader ?
    `background-color: ${props.isActive ? CLASSROOM_TYPE_COLOR_HOVER.active : CLASSROOM_TYPE_COLOR_HOVER[props.type]}` :
    ''};
  }
`
const ListItemIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  margin-right: 16px;
  border-radius: 4px;
  background-color: ${props => props.isActive && props.type !== 'Sick Room' ? CLASSROOM_TYPE_COLOR.active : CLASSROOM_TYPE_COLOR[props.type]};
`
const ListItemInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: ${props => props.icon ? '75%' : '100%'};
`
const ListItemName = styled.span`
  color: ${props => props.isActive ? CLASSROOM_TYPE_COLOR_INFO.active : CLASSROOM_TYPE_COLOR_INFO[props.type]};
`
const ListItemContext = styled.span`
  color: ${props => props.isActive ? 'white' : 'black'};
  opacity: ${props => props.isActive ? 1 : 0.3};
`

class ListItem extends Component {
  onItemClick = () => this.props.onItemClick(this.props.id)

  render() {
    const {
      context,
      icon,
      isActive,
      isHeader,
      name,
      type,
    } = this.props

    return (
      <ListItemContainer
        isHeader={isHeader}
        type={type}
        onClick={this.onItemClick}
        isActive={isActive}
      >
        {icon && (
          <ListItemIcon type={type} isActive={isActive}>
            <img src={CLASSROOM_TYPE_ICON[icon] || CLASSROOM_TYPE_ICON.inactive} alt="type" />
          </ListItemIcon>
        )}
        <ListItemInfo icon={icon}>
          <ListItemName type={type} isActive={isActive}>{name}</ListItemName>
          <ListItemContext isActive={isActive}>{context}</ListItemContext>
        </ListItemInfo>
      </ListItemContainer>
    )
  }
}

ListItem.propTypes = {
  /** Icon on the left of the row */
  icon: PropTypes.string,
  /** Type of the classroom or row in general,
  it could be symptom or inactive(default) and changes the color depends on it */
  type: PropTypes.string,
  /** The name of the item that the row represents */
  name: PropTypes.string.isRequired,
  /** It's aditional data shown on the row, like the capacity and the students */
  context: PropTypes.string.isRequired,
  /** If this is true, the row won't have any click event and icon */
  isHeader: PropTypes.bool,
  /** this event is trigger when the row is clicked */
  onItemClick: PropTypes.func.isRequired,
  /** Id for the row, and is passed as an argument when the onItemClick is triggered */
  id: PropTypes.number,
  /** this set active this row, and changes the color */
  isActive: PropTypes.bool,
}

ListItem.defaultProps = {
  icon: undefined,
  type: 'inactive',
  isHeader: false,
  id: 0,
  isActive: false,
}

export default ListItem



// WEBPACK FOOTER //
// ./src/Components/ClassRoomList/ListItem.jsx